
export default function WriteupInProgress() {
  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <br/>
      <span style={{ color: 'orange' }}>This Writeup is still in progress. Images, content, etc. could be missing!</span>
      <br/>
    </div>
  )
}